import * as React from 'react';
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import { useQuoteFilterSelectionStore } from 'src/hooks/component/quote-filter-selection';
import Common from '../Common';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const QuoteDetailFilterPopup = (props) => {
    const [status, SetStatus] = useState(false);
    const [formData, setFormData] = useState({ manufacturer: '', manufacturerPartNumber: '', customerPartNumber: '' })
    const [{ QuoteDetailFilterPopup }, {}, {}] = useDOMAttachToSystemStore();
    const [{ filter_list }, { }, { set_filter_list }] = useQuoteFilterSelectionStore();
    const [validationDetail, setValidationDetail] = useState({});
    const charMsg = "Please enter at least 3 characters to execute a keyword search.";

    const searchList = [
        { searchKey: "manufacturerPartNumber", searchType: "Manufacturer Part Number", searchKeyword: "" },
        { searchKey: "customerPartNumber", searchType: "Customer Part Number", searchKeyword: "" },
        { searchKey: "manufacturer", searchType: "Manufacturer", searchKeyword: "" }
    ]

    useEffect(() => {
        if (filter_list?.length > 0) {
            Object.keys(filter_list).forEach((property) => {
                setFormData({ ...formData, [filter_list[property].searchKey]: filter_list[property].searchKeyword })
            });
        }
    }, []);

    useEffect(() => {
        if (QuoteDetailFilterPopup) {
            SetStatus(true)
        }
    }, [QuoteDetailFilterPopup]);

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const onValueChange = (field, value) => {
        setFormData({ ...formData, [field]: value });
        validateOnChange(field, value);
    }
    const validateOnChange = (field, value) => {
        if (field === 'customerPartNumber' || field === 'manufacturer' || field === 'manufacturerPartNumber') {
            if (value) {
                const isValid = Common.validateMinCharacter(value);
                if (isValid) {
                    let validateData = { ...validationDetail };
                    delete validateData[field];
                    setValidationDetail(validateData)
                }
            }
            else {
                let validateData = { ...validationDetail };
                delete validateData[field];
                setValidationDetail(validateData)
            }
        }
    }
    const onApplyFilter = () => {
        let data = formData;
        const isValid = checkValidation(data);
        if (isValid) {
            let orderSearch = [];
            Object.keys(formData).forEach((property) => {
                
                if (formData[property]) {
                    let searchObj = searchList.find(f => f.searchKey === property)
                    if (searchObj) {
                        searchObj.searchKeyword = formData[property].trim();
                        orderSearch.push(searchObj);
                    }
                }
            });
            set_filter_list(orderSearch)
            onHide();
        }
    }

    const checkValidation = (data) => {
        let validateData = {};
        Object.keys(data).forEach((property) => {
            if (property === 'customerPartNumber' || property === 'manufacturer' || property === 'manufacturerPartNumber') {
                if (data[property]) {
                    const isValid = Common.validateMinCharacter(data[property]);
                    if (isValid === false) {
                        validateData[property] = charMsg;
                    }
                    else {
                        delete validateData[property];
                    }
                }
                else {
                    delete validateData[property];
                }
            }
        });
        setValidationDetail(validateData)
        return Object.keys(validateData).length > 0 ? false : true;
    }

    return (
        <>
            <Modal show={status} onHide={() => { onHide() }}>
                <div className=" avnet-modal modal-800">

                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>×</button>
                        <div className="modal-header">
                            <h4 className="modal-title text-center">Filter Quotes</h4>
                        </div>
                        <div className="modal-body">
                            <div className="row bs5">
                                <div className="form-group col-6">
                                    <label htmlFor="usr">Manufacturer:</label>
                                    <input type="text" className="form-control" id="manufacturer" placeholder="Manufacturer"
                                        value={formData.manufacturer} onChange={({ target: { value } }) => onValueChange('manufacturer', value)}
                                    />
                                    {validationDetail.manufacturer && <span className="required-alert">{validationDetail.manufacturer}</span>}
                                </div>
                                <div className="form-group col-6">
                                    <label htmlFor="usr">Manufacturer Part Number:</label>
                                    <input type="text" className="form-control" id="manufacturerPartNumber" placeholder="Manufacturer Part Number"
                                        value={formData.manufacturerPartNumber} onChange={({ target: { value } }) => onValueChange('manufacturerPartNumber', value)}
                                    />
                                    {validationDetail.manufacturerPartNumber && <span className="required-alert">{validationDetail.manufacturerPartNumber}</span>}
                                </div>
                            </div>
                            <div className="row bs5">
                                <div className="form-group col-6">
                                    <label htmlFor="usr">Customer Part Number:</label>
                                    <input type="text" className="form-control" id="customerPartNumber" placeholder="Customer Part Number"
                                        value={formData.customerPartNumber} onChange={({ target: { value } }) => onValueChange('customerPartNumber', value)} />
                                    {validationDetail.customerPartNumber && <span className="required-alert">{validationDetail.customerPartNumber}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer text-center">
                            <button type="button" className="bs5 btn btn-secondary" data-dismiss="modal"
                                onClick={() => { onHide() }}>Close</button>
                            <button type="button" className="bs5 btn btn-primary"
                                onClick={() => { onApplyFilter() }}>Apply filters</button>
                        </div>
                    </div>

                </div>

            </Modal>

        </>
    )
}

export default QuoteDetailFilterPopup;